// extracted by mini-css-extract-plugin
module.exports = {"crop":"YSUOZqFi"};